/**
 * mreadweb  api
 */
let BASE_URL = '';
let BASE_URL_ESSAY = 'https://essay.feihua100.com';

if (process.env.VUE_APP_BUILD_ENV === 'test') {
    BASE_URL_ESSAY = 'https://test-origin.feihua100.com';
}

if (process.env.NODE_ENV === 'development') {
    BASE_URL = '/dev';
    // BASE_URL = 'https://api.baijia.com/mock/7394/feihua';
}
interface apiObject {
    [key: string]: any;
}

const api:apiObject = {
    // 分享学习报告页面
    studyReportSharePage: `${BASE_URL}/api/feihua/v1/course/shareDetail`,
    studyReportSharePage2: `${BASE_URL}/api/feihua/v2/course/shareDetail`,
    // 我的作品分享
    myWorkSharePage: `${BASE_URL}/api/feihua/v1/user/opus/shareDetail`,
    // APP下载版本获取
    appVerDownLoad: `${BASE_URL}/api/feihua/v1/pub/upgradShare`,
    weixin: {
        // 获取微信分享的配置信息
        config: `${BASE_URL}/api/feihua/v1/share/sign`
    },

    // 获取课程介绍
    courseIntroduction: `${BASE_URL}/api/feihua/v1/course/fetchCourseIntroduction`,

    // 支付相关
    wxH5Login: `${BASE_URL}/api/feihua/v1/user/wxH5Login`,
    getUserInfo: `${BASE_URL}/api/feihua/v1/user/getUserInfo`,
    sendMsgCode: `${BASE_URL}/api/feihua/v1/user/sendMsgCode`,
    bindPhone: `${BASE_URL}/api/feihua/v1/user/bindPhone`,
    detail: `${BASE_URL}/api/feihua/v3/pay/h5/detail`,
    opti: `${BASE_URL}/api/feihua/v2/pay/h5/detail`,
    createOrder: `${BASE_URL}/api/feihua/v1/pay/h5/createOrder`,
    orderLoop: `${BASE_URL}/api/feihua/v1/pay/h5/order/loop`,
    orderList: `${BASE_URL}/api/feihua/v1/pay/h5/order/list`,
    refundReason: `${BASE_URL}/api/feihua/v1/order/refundApply`,
    refundOrder: `${BASE_URL}/api/feihua/v1/pay/h5/order/refundOrder`,
    obtainCoupon: `${BASE_URL}/api/feihua/v1/coupon/obtainCoupon`,
    wxH5LoginSimple: `${BASE_URL}/api/feihua/v1/user/wxH5LoginSimple`,
    expRightsReceive: `${BASE_URL}/api/feihua/v1/user/rights/expRightsReceive`,
    fetchTeacherInfo: `${BASE_URL}/api/feihua/v2/user/exp/fetchTeacherInfo`,
    fetchTeacherQcode: `${BASE_URL}/api/feihua/v2/user/exp/fetchTeacherQCode`,
    fetchUserStartDate: `${BASE_URL}/api/feihua/v2/user/exp/fetchUserStartDate`,
    invalidSource: `${BASE_URL}/api/feihua/v2/user/exp/invalidSource`,
    // 背诵分享页
    shareDetail: `${BASE_URL}/api/feihua/v1/picBook/recite/shareDetail`,
    // 优惠券
    activityExpired: `${BASE_URL}/api/feihua/v1/activity/isExpired`,
    activityMyDetail: `${BASE_URL}/api/feihua/v1/activity/pricingTestEntry`,
    // 兑换码
    payRedeem: `${BASE_URL}/api/feihua/v1/pay/redeem`,

    // 打卡0元学
    fetchClockType: `${BASE_URL}/api/feihua/v2/course/fetchClockType`,
    punchCardData: `${BASE_URL}/api/feihua/v1/course/dailyAttend/record`,
    cashDetail: `${BASE_URL}/api/feihua/v1/course/dailyAttend/withdrawCheck`,


    // 联合会员领取页面
    combinationInfo: `${BASE_URL}/api/feihua/v1/pay/order/combinationInfo`,
    openCombinationRight: `${BASE_URL}/api/feihua/v1/pay/order/openCombinationRight`,

    // 作文超人 —— 获取作文超人思维导图详情内容
    getEssayContent: `${BASE_URL_ESSAY}/api/essay/v1/user/essay/content`,
    // 作文超人 —— 上报评分
    uploadScore: `${BASE_URL_ESSAY}/api/essay/v1/openai/upload/score`,
};

export default api;

